import { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import { LOGIN_OR_SIGNUP_PATH } from 'paths'

import store from 'redux/store'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { UserService } from 'api/clients/UserService'

import { authMerge } from 'redux/actions'
import { useDispatch } from 'react-redux'
import { useSession } from 'hooks/useSession'
import { companyDetailToWorkspace } from 'utils/workspaceUtils'
import RightPanelContent from '../RightPanelContent/RightPanelContent'

import Shared from '../../Shared.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import ProgressBar from '../ProgressBar/ProgressBar'

type Props = {
  transitionPage: (page: string) => void
  isInvitedUser: boolean
  setNewlyCreatedWorkspaceId: (id: number) => void
}
/**
 * This is a utility component that will immediately redirect after posting and seeding a default workspace
 */
const CreateWorkspace = ({ transitionPage, isInvitedUser, setNewlyCreatedWorkspaceId }: Props) => {
  const { isTabletPortrait } = useResponsiveDesign()
  const dispatch = useDispatch()
  const { auth } = useSession()

  const createWorkspace = async () => {
    transitionPage('COMPANY_DATA')
    const workspaces = store.getState().workspace.workspaces
    const res = await client.postUserCompany(`${auth?.display_name}'s Workspace`)

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      const { company } = res.data
      const newWorkspace = companyDetailToWorkspace(company)
      setNewlyCreatedWorkspaceId(newWorkspace.id)

      dispatch(
        authMerge({
          auth: {
            last_workspace_id: newWorkspace.id,
            company_id: newWorkspace.id,
          },
        }),
      )

      UserService.setWorkspaces([...workspaces, newWorkspace])
      UserService.setCurrentWorkspaceId(newWorkspace.id)
      return newWorkspace
    }
  }

  useEffect(() => {
    createWorkspace()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!auth) return <Redirect to={LOGIN_OR_SIGNUP_PATH} />

  return (
    <div data-testid="createWorkspace" className={Shared.content}>
      <div className={Shared.largerLeftContent}>
        {isTabletPortrait ? (
          <ProgressBar totalSteps={5} currentStep={2} />
        ) : (
          <ProgressBar totalSteps={4} currentStep={1} />
        )}
      </div>
      {!isTabletPortrait && <RightPanelContent screen="createAccount" />}
    </div>
  )
}

export default CreateWorkspace
